import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35485cda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "delete_content" }
const _hoisted_2 = { class: "delete_icon" }
const _hoisted_3 = {
  key: 0,
  class: "delete_text"
}
const _hoisted_4 = {
  key: 1,
  class: "delete_text"
}
const _hoisted_5 = { class: "delete_btn" }

import { withDefaults, useSlots } from 'vue';
import { Modal } from 'ant-design-vue';

export interface RootModal {
  title: string;
  visible: boolean;
  loading: boolean;
}
interface Props {
  title?: any;
  visible: boolean;
  loading?: boolean;
  centered?: boolean;
  closable?: boolean;
  footer?: null;
  close: (...args: any[]) => any;
  ok: (...args: any[]) => any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CReductionAll',
  props: {
    title: null,
    visible: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    centered: { type: Boolean, default: false },
    closable: { type: Boolean, default: false },
    footer: null,
    close: null,
    ok: null
  },
  setup(__props: any) {

const props = __props as { title?: any, visible: boolean, loading: boolean, centered: boolean, closable: boolean, footer?: null, close: (...args: any[]) => any, ok: (...args: any[]) => any };

const aModal = Modal;
const solts = useSlots();


return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createBlock(_unref(aModal), {
    visible: props.visible,
    centered: props.centered,
    title: props.title,
    closable: props.closable,
    footer: null
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_svg_icon, { "icon-class": "warning" })
        ]),
        (_unref(solts).title)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "title")
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, "此操作将全部恢复，是否继续？"))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_a_button, {
          class: "mod_modal_btn",
          onClick: props.close
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          class: "mod_modal_btn mod_type_primary",
          onClick: props.ok
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 3
  }, 8, ["visible", "centered", "title", "closable"]))
}
}

})